/*
 * @Autor: lmlss
 * @Date: 2024-07-15 10:51:28
 * @Description:
 * @LastEditors: lmlss
 * @LastEditTime: 2024-08-27 21:59:20
 */
import {
  cancelNotice,
  dealNotice,
  queryNoticedDetail,
  saveNoticeToTemplate,
} from "../api";
import { Alert, Button, Modal, Tag, notification } from "antd";
import { FC, useCallback, useEffect, useState } from "react";
import { ExtendFileCard } from "./ExtendFileCard";
import "./index.less";
import { CommonFile, CommonUser } from "marmot_design_ui";
import React from "react";
import AppService from "../../../../app.service";

export interface iNoticeDetail {
  noticeId: string;
  title: string;
  info: string;
  msgTypeName: string;
  receivePersonResultType:
    | "DO_READ"
    | "DO_BUTTON"
    | "DO_SIGN"
    | "UNDO_READ"
    | "UNDO_BUTTON"
    | "UNDO_SIGN";
  levelId: number;
  noticeUserDetail: {
    userId: string;
    dealFlag: boolean;
    signFile: CommonFile;
    receivePersonResultType:
      | "DO_READ"
      | "DO_BUTTON"
      | "DO_SIGN"
      | "UNDO_READ"
      | "UNDO_BUTTON"
      | "UNDO_SIGN";
    singDate: string;
  };
  levelName: string;
  noticeSendClient: "PC" | "MAPP";
  templateSaveFlg: boolean;
  publishUser: CommonUser;
  commonFileList: CommonFile[];
  commonMediaList: CommonFile[];
  zipFile: CommonFile;
  publishTime: string;
}

interface iProps {
  actions?: ("cancel" | "recall" | "template" | "update")[];
  noticeId: string;
  visible: boolean;
  onCancel: () => void;
  refresh: () => void;
}

export const DetailModal: FC<iProps> = ({
  actions = [],
  noticeId,
  visible,
  onCancel,
  refresh,
}) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<iNoticeDetail>();

  const initData = async () => {
    setLoading(true);

    // queryNoticedDetail
    const data = await new AppService().getNoticeDetail(noticeId);
    if (data) {
      // @ts-ignore
      setData(data);

      console.log(data, "data11");

      // @ts-ignore
      if (data?.noticeUserDetail?.receivePersonResultType === "UNDO_READ") {
        dealNotice({ noticeId });
      }
    }

    setLoading(false);
  };

  useEffect(() => {
    initData();
  }, []);

  const handleUpdate = () => {};

  const handleRecallAndCancel = (isRecall = false) => {
    Modal.confirm({
      title: "提示",
      content: isRecall ? (
        <>
          <p>确定撤回当前通知吗？</p>
          <p>通知撤回后接收端将不再显示</p>
        </>
      ) : (
        <>
          <p>确定取消发布当前通知吗?</p>
          <p>通知取消发布后将从列表删除</p>
        </>
      ),
      okType: "danger",
      onOk: async () => {
        setLoading(true);

        const { data } = await cancelNotice({ noticeId });

        if (data) {
          notification["success"]({ message: "操作成功" });
          setLoading(false);
          refresh?.();
          onCancel();
        }

        setLoading(false);
      },
    });
  };

  const handleSaveToTemplate = async () => {
    const { data } = await saveNoticeToTemplate({ noticeId });

    if (!data) return;

    notification["success"]({ message: "操作成功" });
    initData();
  };

  const footerBtnMap = {
    template: (
      <Button disabled={!!data?.templateSaveFlg} onClick={handleSaveToTemplate}>
        {data?.templateSaveFlg ? "已保存至模板" : "保存至模板"}
      </Button>
    ),
    recall: <Button onClick={() => handleRecallAndCancel(true)}>撤回</Button>,
    cancel: (
      <Button onClick={() => handleRecallAndCancel(false)}>取消发布</Button>
    ),
    update: (
      <Button type="primary" onClick={handleUpdate}>
        修改
      </Button>
    ),
  };

  const getRightContent = useCallback(() => {
    if (!data) return null;

    const { noticeId } = data;
    const receivePersonResultType =
      data?.noticeUserDetail?.receivePersonResultType || "";

    if (
      !["UNDO_SIGN", "DO_SIGN", "UNDO_BUTTON", "DO_BUTTON"].includes(
        receivePersonResultType
      )
    )
      return null;

    const textMap = {
      UNDO_SIGN: "去签字",
      DO_SIGN: "重新签字",
      UNDO_BUTTON: "确认收到",
      DO_BUTTON: "已确认",
    };

    const handleItem = async () => {
      if (["DO_SIGN", "UNDO_SIGN"].includes(receivePersonResultType)) {
        notification["info"]({ message: "请去小程序签字" });
      }
      if (receivePersonResultType === "UNDO_BUTTON") {
        const { data } = await dealNotice({ noticeId });
        if (data) {
          notification["success"]({ message: "操作成功" });
          onCancel();
        }
      }
    };

    if (receivePersonResultType === "UNDO_SIGN") {
      return (
        <div className="modal-footer-custom">
          <Button type="primary" onClick={handleItem}>
            {textMap?.[receivePersonResultType]}
          </Button>
        </div>
      );
    }
    if (receivePersonResultType === "DO_SIGN") {
      return (
        <div className="modal-footer-custom">
          <img
            width={80}
            height={20}
            src={data?.noticeUserDetail?.signFile?.fileUrl || ""}
          />
          <div className="confirm-text">
            {data?.noticeUserDetail?.singDate} 已确认签字
          </div>
          <Button type="primary" onClick={handleItem}>
            {textMap?.[receivePersonResultType]}
          </Button>
        </div>
      );
    }

    return (
      <Button
        type="primary"
        disabled={["DO_BUTTON"].includes(receivePersonResultType)}
        onClick={handleItem}
      >
        {textMap?.[receivePersonResultType]}
      </Button>
    );
  }, [data]);

  return (
    <Modal
      title="通知详情"
      visible={visible}
      width="950px"
      centered
      confirmLoading={loading}
      onCancel={onCancel}
      className={`detailModal ${
        data?.receivePersonResultType === "UNDO_SIGN" &&
        "detailModal-hasPaddingTop"
      }`}
      footer={getRightContent()}
      maskClosable={false}
    >
      {data?.receivePersonResultType === "UNDO_SIGN" && (
        <Alert
          message="此通知需仔细阅读并签字，请前往小程序签字确认"
          type="warning"
          style={{ marginBottom: 24, marginLeft: -24, marginRight: -24 }}
        />
      )}
      <div className="detail-modal-wrapper">
        <div className="title">
          {data?.title || "-"}
          {/* @ts-ignore */}
          {data?.tagType === "EMERGENT" && (
            <Tag className="title-tag" color="#FF4D4F">
              紧急
            </Tag>
          )}
        </div>
        <div className="sub-title">
          {data?.msgTypeName && (
            <div className="tags">
              <Tag>{data?.msgTypeName}</Tag>
            </div>
          )}
          <div className="publish">
            <div>{data?.publishUser?.fullName || "-"}</div>
            <div>发布于 {data?.publishTime || "-"}</div>
          </div>
        </div>
        <div dangerouslySetInnerHTML={{ __html: data?.info || "-" }} />
        <ExtendFileCard
          fileList={[
            ...(!!data?.commonMediaList?.length ? data?.commonMediaList : []),
            ...(!!data?.commonFileList?.length ? data?.commonFileList : []),
          ]}
          zipFile={data?.zipFile}
        />
      </div>
    </Modal>
  );
};
